export const parseFormNumber = (raw: string | undefined | null): number => {
  if (raw == null || raw === "") {
    return 0;
  }
  const normalized = raw.toString().replace(/\s/g, "").replace(",", ".");
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};
